import {
	applyApMacAclFilter,
	focusApMacAcl,
	openApMacAclSection,
} from './adapter';
import {
	openApMacAclCreateModal,
	openApMacAclEditModal,
	openApMacAclDeleteModal,
} from './modal';
import {resolveApMacAcl} from './resolver';

/**
 * Access Point MAC ACL.
 *
 * The first of the two MAC ACL tabs. Named ap_mac_acl because
 * "mac acl" already answers as the SSID field of that name.
 *
 * Declares no fields: the agent finds one and opens the form rather than
 * filling it in.
 */
const apMacAclPlugin = {
	id: 'ap_mac_acl',
	version: 1,
	commandVersion: 1,
	resource: 'ap_mac_acl',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.ap_mac_acls': openApMacAclSection,
	},
	resolvers: {
		ap_mac_acl: resolveApMacAcl,
	},
	filters: {
		ap_mac_acl: (command) =>
			applyApMacAclFilter(command.params?.query),
	},
	focusHandlers: {
		ap_mac_acl: (command) =>
			focusApMacAcl(command.params?.entity_id),
	},
	modals: {
		'ap_mac_acl.create': openApMacAclCreateModal,
		'ap_mac_acl.edit': openApMacAclEditModal,
		'ap_mac_acl.delete': openApMacAclDeleteModal,
	},
};

export default apMacAclPlugin;
